/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { FormControl } from '@mui/material';
import { Controller } from 'react-hook-form';
import dayjs, { Dayjs } from 'dayjs';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import 'dayjs/locale/pt-br';

export type DatePickerProps = {
  name: string;
  label: string;
  control: any;
  minWidth?: string;
  maxWidth?: string;
  returnFormat?: string;
};

export function MuiDatePicker({
  name,
  label,
  minWidth,
  maxWidth,
  control,
  returnFormat = 'DD/MM/YYYY',
}: DatePickerProps) {
  return (
    <FormControl
      sx={{
        minWidth: minWidth ? minWidth : '200px',
        maxWidth: maxWidth ? maxWidth : '200px',
      }}
      variant="outlined"
    >
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="pt-br"
          >
            <DesktopDatePicker
              label={label}
              format="DD/MM/YYYY"
              value={value ? dayjs(value, returnFormat) : null}
              onChange={(date: Dayjs | null) => {
                onChange(date ? date.format(returnFormat) : null);
              }}
              closeOnSelect
              views={['year', 'month', 'day']}
              sx={{
                width: '400px',
              }}
            />
          </LocalizationProvider>
        )}
      />
    </FormControl>
  );
}
